import { Component, Link } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import Results from 'pages/find-care-options/care-options-result/Results'
import serviceLocations from 'server/triage/actions/test/getServiceLocationsRes.js'

export default class CareOptionsResult extends Component {

  state = {
    isLoading: true
  }

  async componentDidMount() {

    const { state, actions } = this.props

    try {

      await actions.setTriageResponse({ serviceLocations })
      actions.generateSessionResults()

      this.setState({ isLoading: false })
      //actions.submitTriageSession()

    } catch(e) {

    }
  }

  render() {
    return (
      <LoadingScreen isLoading={this.state.isLoading} minDuration={0}>
        <Results {...this.props} />
      </LoadingScreen>
    )
  }
}
